/** 体彩P3P5 近期开奖（与参考图一致，最新在前） */
export const SAMPLE_P3P5 = [
  { issue: '2026215', codes: [9, 2, 7, 3, 8] },
  { issue: '2026214', codes: [2, 3, 4, 8, 7] },
  { issue: '2026213', codes: [2, 4, 6, 6, 4] },
  { issue: '2026212', codes: [6, 6, 3, 3, 2] },
  { issue: '2026211', codes: [1, 1, 6, 8, 5] },
  { issue: '2026210', codes: [5, 4, 3, 6, 4] },
  { issue: '2026209', codes: [3, 7, 8, 2, 5] },
  { issue: '2026208', codes: [7, 3, 6, 7, 3] },
  { issue: '2026207', codes: [4, 4, 8, 0, 6] },
  { issue: '2026206', codes: [6, 4, 1, 1, 6] },
  { issue: '2026205', codes: [3, 3, 8, 4, 7] },
  { issue: '2026204', codes: [6, 7, 4, 0, 7] },
  { issue: '2026203', codes: [4, 4, 4, 0, 3] },
  { issue: '2026202', codes: [8, 2, 6, 0, 6] },
  { issue: '2026201', codes: [6, 8, 5, 2, 4] },
  { issue: '2026200', codes: [6, 8, 0, 4, 6] },
  { issue: '2026199', codes: [8, 3, 8, 3, 5] },
  { issue: '2026198', codes: [4, 8, 3, 7, 9] },
  { issue: '2026197', codes: [6, 5, 3, 3, 7] },
  { issue: '2026196', codes: [2, 1, 1, 6, 8] },
  { issue: '2026195', codes: [4, 1, 5, 9, 4] },
  { issue: '2026194', codes: [7, 0, 1, 0, 6] }
]

export const PERIOD_OPTIONS = [
  { value: 30, label: '最近30期' },
  { value: 50, label: '最近50期' },
  { value: 100, label: '最近100期' }
]

export const CHART_TABS = [
  { key: 'line', label: '走势图' },
  { key: 'kline', label: 'K线图' },
  { key: 'hist', label: '直方图' }
]

export const STAT_ROWS = [
  { key: 'count', label: '出现总次数' },
  { key: 'avg', label: '平均遗漏值' },
  { key: 'maxMiss', label: '最大遗漏值' },
  { key: 'maxStreak', label: '最大连出值' }
]

export const getDigitLen = (game) => {
  if (!game) return 5
  if (Number(game.id) === 16 || Number(game.id) === 17) return 7
  if (game.group === 'K3' || game.group === 'PCB') return 3
  if (game.group === 'PK10') return 10
  if (game.group === 'LHC') return 7
  if (game.group === '11X5' || game.group === 'SSC') return 5
  if (game.group === 'KENO') return 20
  if (/双色球|SSQ/.test(game.name || '')) return 7
  if (/大乐透|DLT/.test(game.name || '') && !/台湾/.test(game.name || '')) return 7
  if (/3D|快三/.test(game.name || '')) return 3
  if (/四星/.test(game.name || '')) return 4
  if (Number(game.id) === 15) return 5
  return 5
}

export const getPositions = (digitLen) => {
  if (digitLen === 3) {
    return [
      { index: 0, name: '百位' },
      { index: 1, name: '十位' },
      { index: 2, name: '个位' }
    ]
  }
  if (digitLen === 4) {
    return [
      { index: 0, name: '千位' },
      { index: 1, name: '百位' },
      { index: 2, name: '十位' },
      { index: 3, name: '个位' }
    ]
  }
  return [
    { index: 0, name: '万位' },
    { index: 1, name: '千位' },
    { index: 2, name: '百位' },
    { index: 3, name: '十位' },
    { index: 4, name: '个位' }
  ]
}

export const COMBO_LABELS = {
  All_5_Complex: '五星综合',
  First_4: '前四',
  Last_4: '后四',
  First_3: '前三',
  Middle_3: '中三',
  Last_3: '后三',
  First_2: '前二',
  Last_2: '后二',
  D3_All: '三星',
  D3_First_2: '前二',
  D3_Last_2: '后二',
  D3_Sum: '和数',
  X4_All: '综合',
  X4_Last_3: '后三',
  X4_Last_2: '后二',
  P3_First_3: 'P3前三',
  P5_Last_3: 'P5后三',
  P3_First_2: 'P3前二',
  P5_Last_2: 'P5后二',
  K3_All: '综合',
  K3_Sum: '和值',
  PCB_All: '综合',
  PCB_Sum: '和值',
  X11_All: '综合',
  DLT_Front: '前区',
  DLT_Back: '后区',
  DLT_Form: '形态',
  SSQ_Red: '红球',
  SSQ_Blue: '蓝球',
  SSQ_Form: '形态'
}

/** 组合走势对应号码区间；带 Sum 的为和值单点走势 */
export const COMBO_RANGE = {
  All_5_Complex: [0, 4],
  First_4: [0, 3],
  Last_4: [1, 4],
  First_3: [0, 2],
  Middle_3: [1, 3],
  Last_3: [2, 4],
  First_2: [0, 1],
  Last_2: [3, 4],
  D3_All: [0, 2],
  D3_First_2: [0, 1],
  D3_Last_2: [1, 2],
  D3_Sum: [0, 2],
  X4_All: [0, 3],
  X4_Last_3: [1, 3],
  X4_Last_2: [2, 3],
  P3_First_3: [0, 2],
  P5_Last_3: [2, 4],
  P3_First_2: [0, 1],
  P5_Last_2: [3, 4],
  K3_All: [0, 2],
  K3_Sum: [0, 2],
  PCB_All: [0, 2],
  PCB_Sum: [0, 2],
  X11_All: [0, 4],
  DLT_Front: [0, 4],
  DLT_Back: [5, 6],
  DLT_Form: [0, 6],
  SSQ_Red: [0, 5],
  SSQ_Blue: [6, 6],
  SSQ_Form: [0, 6]
}

/** 和值类组合：单列走势（有折线）；福彩3D「和数」走形态表，不含在此 */
export const SUM_COMBO_KEYS = new Set(['PCB_Sum'])

export const P3P5_RATIO_KEYS = ['5:0', '4:1', '3:2', '2:3', '1:4', '0:5']

export const calcCodesSum = (codes) =>
  (codes || []).reduce((sum, n) => sum + Number(n || 0), 0)

/** 五星综合：0–4 为小，5–9 为大 */
export const calcDigitBigSmallRatio = (codes) => {
  const list = codes || []
  let big = 0
  list.forEach((n) => {
    if (Number(n) >= 5) big += 1
  })
  const small = list.length - big
  return `${big}:${small}`
}

/** 五星综合：奇偶比 */
export const calcDigitOddEvenRatio = (codes) => {
  const list = codes || []
  let odd = 0
  list.forEach((n) => {
    if (Number(n) % 2) odd += 1
  })
  const even = list.length - odd
  return `${odd}:${even}`
}

export const buildP3p5ComplexRows = (draws, ratioKeys = P3P5_RATIO_KEYS) => {
  const size = ratioKeys.length
  const oldest = [...draws].reverse()
  const bsLast = Array(size).fill(-1)
  const oeLast = Array(size).fill(-1)

  const computed = oldest.map((draw, i) => {
    const codes = draw.codes || []
    const sum = calcCodesSum(codes)
    const bsRatio = calcDigitBigSmallRatio(codes)
    const oeRatio = calcDigitOddEvenRatio(codes)
    const bsHit = ratioKeys.indexOf(bsRatio)
    const oeHit = ratioKeys.indexOf(oeRatio)
    const bsMiss = Array(size).fill(0)
    const oeMiss = Array(size).fill(0)

    for (let d = 0; d < size; d++) {
      if (d === bsHit) {
        bsMiss[d] = 0
        bsLast[d] = i
      } else {
        bsMiss[d] = bsLast[d] < 0 ? i + 1 : i - bsLast[d]
      }
      if (d === oeHit) {
        oeMiss[d] = 0
        oeLast[d] = i
      } else {
        oeMiss[d] = oeLast[d] < 0 ? i + 1 : i - oeLast[d]
      }
    }

    return {
      issue: draw.issue,
      codes,
      sum,
      bsRatio,
      oeRatio,
      bsHit,
      oeHit,
      bsMiss,
      oeMiss
    }
  })

  return computed.reverse()
}

/** 质数球：1/2/3/5/7 为质，其余为合 */
export const DIGIT_PRIME_SET = new Set([1, 2, 3, 5, 7])

export const calcDigitBigSmall = (n) => (Number(n) >= 5 ? '大' : '小')
export const calcDigitOddEven = (n) => (Number(n) % 2 ? '单' : '双')
export const calcDigitPrimeComposite = (n) => (DIGIT_PRIME_SET.has(Number(n)) ? '质' : '合')

/** 三位形态：豹子 / 组三 / 组六 */
export const calcTripleForm = (codes) => {
  const list = (codes || []).slice(0, 3).map(Number)
  if (list.length < 3) return ''
  const uniq = new Set(list).size
  if (uniq === 1) return 'baozi'
  if (uniq === 2) return 'zu3'
  return 'zu6'
}

/**
 * 三位形态走势行（P3前三 / P5后三 / 福彩3D三星）：
 * 大小 / 单双 / 质合 + 和值 + 组三 / 组六 / 豹子遗漏
 * @param {Array} draws 最新在前
 * @param {[number, number]} range 默认前三位 [0,2]
 */
export const buildP3First3Rows = (draws, range = [0, 2]) => {
  const [from, to] = range
  const oldest = [...draws].reverse()
  let zu3Last = -1
  let zu6Last = -1
  let baoziLast = -1

  const computed = oldest.map((draw, i) => {
    const codes = draw.codes || []
    const triple = codes.slice(from, to + 1)
    const bs = triple.map(calcDigitBigSmall)
    const oe = triple.map(calcDigitOddEven)
    const pc = triple.map(calcDigitPrimeComposite)
    const form = calcTripleForm(triple)

    let zu3Miss = 0
    let zu6Miss = 0
    let baoziMiss = 0

    if (form === 'zu3') {
      zu3Last = i
      zu3Miss = 0
    } else {
      zu3Miss = zu3Last < 0 ? i + 1 : i - zu3Last
    }
    if (form === 'zu6') {
      zu6Last = i
      zu6Miss = 0
    } else {
      zu6Miss = zu6Last < 0 ? i + 1 : i - zu6Last
    }
    if (form === 'baozi') {
      baoziLast = i
      baoziMiss = 0
    } else {
      baoziMiss = baoziLast < 0 ? i + 1 : i - baoziLast
    }

    const nums = triple.map((n) => Number(n) || 0)
    const sum = nums.reduce((a, b) => a + b, 0)

    return {
      issue: draw.issue,
      codes,
      triple: nums,
      sum,
      bs,
      oe,
      pc,
      form,
      zu3Miss,
      zu6Miss,
      baoziMiss
    }
  })

  return computed.reverse()
}

/** P3 前三 / 福彩3D 三星底部统计（组三 / 组六 / 豹子） */
export const computeP3First3Stats = (rows) => {
  const n = rows.length
  const keys = ['zu3', 'zu6', 'baozi']
  const count = { zu3: 0, zu6: 0, baozi: 0 }
  const maxMiss = { zu3: 0, zu6: 0, baozi: 0 }
  const maxStreak = { zu3: 0, zu6: 0, baozi: 0 }
  const missRun = { zu3: 0, zu6: 0, baozi: 0 }
  const hitRun = { zu3: 0, zu6: 0, baozi: 0 }

  ;[...rows].reverse().forEach((row) => {
    keys.forEach((key) => {
      if (row.form === key) {
        count[key] += 1
        hitRun[key] += 1
        missRun[key] = 0
        maxStreak[key] = Math.max(maxStreak[key], hitRun[key])
      } else {
        hitRun[key] = 0
        missRun[key] += 1
        maxMiss[key] = Math.max(maxMiss[key], missRun[key])
      }
    })
  })

  const avg = {}
  keys.forEach((key) => {
    avg[key] = count[key] ? Math.round((n - count[key]) / count[key]) : n
  })

  return { count, avg, maxMiss, maxStreak }
}

/**
 * 福彩3D 和数走势：百十 / 百个 / 十个 / 百十个 的和数与和尾（合尾）
 * @param {Array} draws 最新在前
 */
export const buildD3SumDigitRows = (draws) =>
  (draws || []).map((draw) => {
    const codes = (draw.codes || []).slice(0, 3).map((n) => Number(n) || 0)
    while (codes.length < 3) codes.push(0)
    const [b, s, g] = codes
    const bt = b + s
    const bg = b + g
    const sg = s + g
    const all = b + s + g
    return {
      issue: draw.issue,
      codes,
      btSum: bt,
      btTail: bt % 10,
      bgSum: bg,
      bgTail: bg % 10,
      sgSum: sg,
      sgTail: sg % 10,
      allSum: all,
      allTail: all % 10
    }
  })

/**
 * 前二 / 后二形态走势行（P3前二 / P5后二 / 福彩3D前二后二）：
 * 大小 / 单双 / 质合 + 和值 / 跨度 / 对子遗漏
 * @param {Array} draws 最新在前
 * @param {[number, number]} range 默认前二位 [0,1]
 */
export const buildP3First2Rows = (draws, range = [0, 1]) => {
  const [from, to] = range
  const oldest = [...draws].reverse()
  let pairLast = -1

  const computed = oldest.map((draw, i) => {
    const codes = draw.codes || []
    const pair = codes.slice(from, to + 1).map(Number)
    const a = Number(pair[0] ?? 0)
    const b = Number(pair[1] ?? 0)
    const bs = pair.map(calcDigitBigSmall)
    const oe = pair.map(calcDigitOddEven)
    const pc = pair.map(calcDigitPrimeComposite)
    const sum = a + b
    const span = Math.abs(a - b)
    const isPair = pair.length >= 2 && a === b

    let pairMiss = 0
    if (isPair) {
      pairLast = i
      pairMiss = 0
    } else {
      pairMiss = pairLast < 0 ? i + 1 : i - pairLast
    }

    return {
      issue: draw.issue,
      codes,
      bs,
      oe,
      pc,
      sum,
      span,
      isPair,
      pairMiss
    }
  })

  return computed.reverse()
}

/** P3 前二底部统计（仅对子） */
export const computeP3First2Stats = (rows) => {
  const n = rows.length
  let count = 0
  let maxMiss = 0
  let maxStreak = 0
  let missRun = 0
  let hitRun = 0

  ;[...rows].reverse().forEach((row) => {
    if (row.isPair) {
      count += 1
      hitRun += 1
      missRun = 0
      maxStreak = Math.max(maxStreak, hitRun)
    } else {
      hitRun = 0
      missRun += 1
      maxMiss = Math.max(maxMiss, missRun)
    }
  })

  const avg = count ? Math.floor((n - count) / count) : n
  return {
    count: { pair: count },
    avg: { pair: avg },
    maxMiss: { pair: maxMiss },
    maxStreak: { pair: maxStreak }
  }
}

export const isSumCombo = (key) => SUM_COMBO_KEYS.has(key)

/** 形态表组合：不走号码多码同开折线 */
const FORM_COMBO_KEYS = new Set([
  'D3_All',
  'D3_First_2',
  'D3_Last_2',
  'D3_Sum',
  'P3_First_3',
  'P5_Last_3',
  'P3_First_2',
  'P5_Last_2',
  'K3_All',
  'K3_Sum',
  'DLT_Form',
  'SSQ_Form'
])

export const isMultiCombo = (key) =>
  Boolean(key) && !isSumCombo(key) && Boolean(COMBO_RANGE[key]) && !FORM_COMBO_KEYS.has(key)

/** 快三和值页：对子(二同号)/组六(三不同)/豹子 + 和值大小单双 */
export function buildK3SumRows (draws) {
  const oldest = [...(draws || [])].reverse()
  let pairLast = -1
  let zu6Last = -1
  let baoziLast = -1

  const computed = oldest.map((draw, i) => {
    const codes = (draw.codes || []).slice(0, 3).map((n) => {
      const v = Number(n) || 1
      return ((v - 1) % 6 + 6) % 6 + 1
    })
    while (codes.length < 3) codes.push(1)
    const form = calcTripleForm(codes)
    const sum = codes.reduce((a, b) => a + b, 0)
    // 快三和值：11–18 大，3–10 小
    const sumBs = sum >= 11 ? '大' : '小'
    const sumOe = sum % 2 ? '单' : '双'

    let pairMiss = 0
    let zu6Miss = 0
    let baoziMiss = 0

    if (form === 'zu3') {
      pairLast = i
      pairMiss = 0
    } else {
      pairMiss = pairLast < 0 ? i + 1 : i - pairLast
    }
    if (form === 'zu6') {
      zu6Last = i
      zu6Miss = 0
    } else {
      zu6Miss = zu6Last < 0 ? i + 1 : i - zu6Last
    }
    if (form === 'baozi') {
      baoziLast = i
      baoziMiss = 0
    } else {
      baoziMiss = baoziLast < 0 ? i + 1 : i - baoziLast
    }

    return {
      issue: draw.issue,
      codes,
      form,
      sum,
      sumBs,
      sumOe,
      pairMiss,
      zu6Miss,
      baoziMiss
    }
  })

  return computed.reverse()
}

export const computeK3SumStats = (rows) => {
  const formMap = { zu3: 'pair', zu6: 'zu6', baozi: 'baozi' }
  const keys = ['pair', 'zu6', 'baozi']
  const count = { pair: 0, zu6: 0, baozi: 0 }
  const maxMiss = { pair: 0, zu6: 0, baozi: 0 }
  const maxStreak = { pair: 0, zu6: 0, baozi: 0 }
  const missRun = { pair: 0, zu6: 0, baozi: 0 }
  const hitRun = { pair: 0, zu6: 0, baozi: 0 }

  ;[...(rows || [])].reverse().forEach((row) => {
    const hitKey = formMap[row.form]
    keys.forEach((key) => {
      if (key === hitKey) {
        count[key] += 1
        hitRun[key] += 1
        missRun[key] = 0
        maxStreak[key] = Math.max(maxStreak[key], hitRun[key])
      } else {
        hitRun[key] = 0
        missRun[key] += 1
        maxMiss[key] = Math.max(maxMiss[key], missRun[key])
      }
    })
  })

  const n = rows?.length || 0
  const avg = {}
  keys.forEach((key) => {
    avg[key] = count[key] ? Math.round((n - count[key]) / count[key]) : n
  })

  return {
    appear: count,
    avgMiss: avg,
    maxMiss,
    maxStreak
  }
}

/** 快三单骰：4–6 大，1–3 小 */
export const k3DiceBs = (n) => (Number(n) >= 4 ? '大' : '小')
export const k3DiceOe = (n) => (Number(n) % 2 ? '单' : '双')

/** 快三组合综合行：三骰大小/单双 + 跨度 */
export function buildK3ComplexRows (draws) {
  return (draws || []).map((draw) => {
    const codes = (draw.codes || []).slice(0, 3).map((n) => {
      const v = Number(n) || 1
      return ((v - 1) % 6 + 6) % 6 + 1
    })
    while (codes.length < 3) codes.push(1)
    const max = Math.max(...codes)
    const min = Math.min(...codes)
    return {
      issue: draw.issue,
      codes,
      balls: codes.map((n) => ({
        n,
        bs: k3DiceBs(n),
        oe: k3DiceOe(n)
      })),
      span: max - min
    }
  })
}

/** 快三综合底部统计：每球「大」「单」为命中，跨度列无统计 */
export const computeK3ComplexStats = (rows) => {
  const n = rows?.length || 0
  const size = 6
  const count = Array(size).fill(0)
  const maxMiss = Array(size).fill(0)
  const maxStreak = Array(size).fill(0)
  const missRun = Array(size).fill(0)
  const hitRun = Array(size).fill(0)

  ;[...(rows || [])].reverse().forEach((row) => {
    const hits = []
    ;(row.balls || []).forEach((ball) => {
      hits.push(ball.bs === '大')
      hits.push(ball.oe === '单')
    })
    for (let i = 0; i < size; i++) {
      if (hits[i]) {
        count[i] += 1
        hitRun[i] += 1
        missRun[i] = 0
        maxStreak[i] = Math.max(maxStreak[i], hitRun[i])
      } else {
        hitRun[i] = 0
        missRun[i] += 1
        maxMiss[i] = Math.max(maxMiss[i], missRun[i])
      }
    }
  })

  const avg = count.map((c) => (c ? Math.round(n / c) : 0))
  return { count, avg, maxMiss, maxStreak }
}

/** 时时彩：万千百十个 + 五星/前四…组合 */
export const SSC_TREND_SETTING = {
  key: 'SSC',
  digitLen: 5,
  ballMin: 0,
  ballMax: 9,
  positions: getPositions(5),
  combos: ['All_5_Complex', 'First_4', 'Last_4', 'First_3', 'Middle_3', 'Last_3', 'First_2', 'Last_2'],
  extras: []
}

/** 体彩 P3P5 */
export const P3P5_TREND_SETTING = {
  key: 'P3P5',
  digitLen: 5,
  ballMin: 0,
  ballMax: 9,
  positions: getPositions(5),
  combos: ['All_5_Complex', 'P3_First_3', 'P5_Last_3', 'P3_First_2', 'P5_Last_2'],
  extras: []
}

/** 福彩3D / 美国3D 等：定位百十个 + 组合三星/前二/后二/和数 */
export const D3_TREND_SETTING = {
  key: 'D3',
  digitLen: 3,
  ballMin: 0,
  ballMax: 9,
  positions: getPositions(3),
  combos: ['D3_All', 'D3_First_2', 'D3_Last_2', 'D3_Sum'],
  extras: []
}

/** 四星彩 */
export const X4_TREND_SETTING = {
  key: 'X4',
  digitLen: 4,
  ballMin: 0,
  ballMax: 9,
  positions: getPositions(4),
  combos: ['X4_All', 'First_3', 'X4_Last_3', 'First_2', 'X4_Last_2'],
  extras: []
}

/** 十一选五：第一～五位（1–11） */
export const X11_TREND_SETTING = {
  key: '11X5',
  digitLen: 5,
  ballMin: 1,
  ballMax: 11,
  positions: [
    { index: 0, name: '第一位' },
    { index: 1, name: '第二位' },
    { index: 2, name: '第三位' },
    { index: 3, name: '第四位' },
    { index: 4, name: '第五位' }
  ],
  combos: ['X11_All', 'First_3', 'Middle_3', 'Last_3', 'First_2', 'Last_2'],
  extras: []
}

/**
 * 超级大乐透（体彩）：前区 01–35 ×5 + 后区 01–12 ×2
 * 定位按开奖展示顺序；组合「前区/后区」为多码同开遗漏表，「形态」为区和/跨度/比
 */
export const DLT_TREND_SETTING = {
  key: 'DLT',
  digitLen: 7,
  ballMin: 1,
  ballMax: 35,
  positions: [
    { index: 0, name: '前一', ballMin: 1, ballMax: 35 },
    { index: 1, name: '前二', ballMin: 1, ballMax: 35 },
    { index: 2, name: '前三', ballMin: 1, ballMax: 35 },
    { index: 3, name: '前四', ballMin: 1, ballMax: 35 },
    { index: 4, name: '前五', ballMin: 1, ballMax: 35 },
    { index: 5, name: '后一', ballMin: 1, ballMax: 12 },
    { index: 6, name: '后二', ballMin: 1, ballMax: 12 }
  ],
  combos: ['DLT_Front', 'DLT_Back', 'DLT_Form'],
  extras: []
}

/**
 * 双色球（福彩）：红球 01–33 ×6 + 蓝球 01–16 ×1
 * 定位按开奖展示顺序；组合「红球/蓝球」为多码同开遗漏表，「形态」为红和/跨度/比 + 蓝大小单双
 */
export const SSQ_TREND_SETTING = {
  key: 'SSQ',
  digitLen: 7,
  ballMin: 1,
  ballMax: 33,
  positions: [
    { index: 0, name: '红一', ballMin: 1, ballMax: 33 },
    { index: 1, name: '红二', ballMin: 1, ballMax: 33 },
    { index: 2, name: '红三', ballMin: 1, ballMax: 33 },
    { index: 3, name: '红四', ballMin: 1, ballMax: 33 },
    { index: 4, name: '红五', ballMin: 1, ballMax: 33 },
    { index: 5, name: '红六', ballMin: 1, ballMax: 33 },
    { index: 6, name: '蓝球', ballMin: 1, ballMax: 16 }
  ],
  combos: ['SSQ_Red', 'SSQ_Blue', 'SSQ_Form'],
  extras: []
}

/** PC蛋蛋 / 28：百十个 + 综合/和值 */
export const PCB_TREND_SETTING = {
  key: 'PCB',
  digitLen: 3,
  ballMin: 0,
  ballMax: 9,
  positions: getPositions(3),
  combos: ['PCB_All', 'PCB_Sum'],
  extras: []
}

const PK10_RANK_NAMES = ['冠军', '亚军', '季军', '第四名', '第五名', '第六名', '第七名', '第八名', '第九名', '第十名']

/** PK10 龙虎对比位：第 N 名 vs 第 (11-N) 名 */
export const PK10_DT_PAIRS = [
  { left: 0, right: 9, head: ['1', 'vs', '10'] },
  { left: 1, right: 8, head: ['2', 'vs', '9'] },
  { left: 2, right: 7, head: ['3', 'vs', '8'] },
  { left: 3, right: 6, head: ['4', 'vs', '7'] },
  { left: 4, right: 5, head: ['5', 'vs', '6'] }
]

export const calcPk10DragonTiger = (codes) => {
  const list = Array.isArray(codes) ? codes : []
  return PK10_DT_PAIRS.map(({ left, right }) => {
    const a = Number(list[left])
    const b = Number(list[right])
    if (!Number.isFinite(a) || !Number.isFinite(b)) return '虎'
    return a > b ? '龙' : '虎'
  })
}

/** PK10 冠亚和：冠军+亚军和值的大小单双（大≥12，小≤11） */
export const calcPk10GyBsOe = (codes) => {
  const list = Array.isArray(codes) ? codes : []
  const sum = Number(list[0]) + Number(list[1])
  if (!Number.isFinite(sum)) return { bs: '小', oe: '双' }
  return {
    bs: sum >= 12 ? '大' : '小',
    oe: sum % 2 ? '单' : '双'
  }
}

/** PK10 单名次大小单双：号码≥6为大，≤5为小 */
export const calcPk10RankBsOe = (n) => {
  const num = Number(n)
  if (!Number.isFinite(num)) return { bs: '小', oe: '双' }
  return {
    bs: num >= 6 ? '大' : '小',
    oe: num % 2 ? '单' : '双'
  }
}

export const PK10_FRONT5_RANKS = ['冠军', '亚军', '季军', '第四名', '第五名']
export const PK10_BACK5_RANKS = ['第六名', '第七名', '第八名', '第九名', '第十名']

export const calcPk10Front5BsOe = (codes) => {
  const list = Array.isArray(codes) ? codes : []
  return [0, 1, 2, 3, 4].map((i) => calcPk10RankBsOe(list[i]))
}

export const calcPk10Back5BsOe = (codes) => {
  const list = Array.isArray(codes) ? codes : []
  return [5, 6, 7, 8, 9].map((i) => calcPk10RankBsOe(list[i]))
}

/** PK10 番摊：前3名号码之和 mod 4，整除为4番；1/2为小，3/4为大；1/3为单，2/4为双 */
export const calcPk10Fantan = (codes) => {
  const list = Array.isArray(codes) ? codes : []
  const sum = Number(list[0]) + Number(list[1]) + Number(list[2])
  if (!Number.isFinite(sum)) return { fan: 1, guFan: '1番', bs: '小', oe: '单' }
  const rem = sum % 4
  const fan = rem === 0 ? 4 : rem
  return {
    fan,
    guFan: `${fan}番`,
    bs: fan >= 3 ? '大' : '小',
    oe: fan % 2 ? '单' : '双'
  }
}

/** 走势下载：期号 + 空格 + 逗号分隔开奖号（PK10 两位补零） */
export const formatDrawDownloadLine = (issue, codes, group) => {
  const pad = group === 'PK10'
    ? (n) => String(Number(n)).padStart(2, '0')
    : (n) => String(Number(n))
  const list = Array.isArray(codes) ? codes : []
  return `${issue} ${list.map(pad).join(',')}`
}

export const buildDrawDownloadText = (rows, group) =>
  rows.map((row) => formatDrawDownloadLine(row.issue, row.codes, group)).join('\n')

/** 解析下载接口返回的纯文本（兼容「期号 号码」与「期号,号码」两种格式） */
export const parseDrawDownloadText = (text) =>
  String(text || '')
    .trim()
    .split('\n')
    .filter(Boolean)
    .map((line) => {
      if (line.includes(' ')) {
        const idx = line.indexOf(' ')
        return {
          issue: line.slice(0, idx),
          codes: line.slice(idx + 1).split(',').map((n) => Number(n))
        }
      }
      const parts = line.split(',')
      return {
        issue: parts[0],
        codes: parts.slice(1).map((n) => Number(n))
      }
    })
    .filter((row) => row.issue && row.codes.length)

/** PK10 / 飞艇：定位冠军至第十名 + 龙虎 / 大小单双 / 番摊 */
export const PK10_TREND_SETTING = {
  key: 'PK10',
  digitLen: 10,
  ballMin: 1,
  ballMax: 10,
  positions: PK10_RANK_NAMES.map((name, index) => ({ index, name })),
  combos: [],
  extras: [
    { title: '龙虎', items: [{ key: 'dt', name: '龙虎' }] },
    {
      title: '大小单双',
      items: [
        { key: 'gy', name: '冠亚和' },
        { key: 'front5', name: '前五' },
        { key: 'back5', name: '后五' }
      ]
    },
    { title: '番摊', items: [{ key: 'fantan', name: '番摊' }] }
  ]
}

/** 快三：定位百十个（1–6）+ 组合综合/和值 */
export const K3_TREND_SETTING = {
  key: 'K3',
  digitLen: 3,
  ballMin: 1,
  ballMax: 6,
  positions: getPositions(3),
  combos: ['K3_All', 'K3_Sum'],
  extras: []
}

export const TREND_SETTING_BY_GAME_ID = {
  15: P3P5_TREND_SETTING,
  14: D3_TREND_SETTING,
  16: DLT_TREND_SETTING,
  17: SSQ_TREND_SETTING,
  19804: D3_TREND_SETTING,
  19803: D3_TREND_SETTING,
  16803: X4_TREND_SETTING,
  10906: X4_TREND_SETTING,
  16804: X4_TREND_SETTING,
  11103: X4_TREND_SETTING
}

export const TREND_SETTING_BY_GROUP = {
  SSC: SSC_TREND_SETTING,
  PK10: PK10_TREND_SETTING,
  K3: K3_TREND_SETTING,
  '11X5': X11_TREND_SETTING,
  PCB: PCB_TREND_SETTING
}

export const getTrendSetting = (game) => {
  const id = game?.id
  if (id != null && TREND_SETTING_BY_GAME_ID[id]) return TREND_SETTING_BY_GAME_ID[id]
  if (game?.group === 'LF') {
    const name = String(game.name || '')
    if (/双色球|SSQ/.test(name)) return SSQ_TREND_SETTING
    if (/大乐透|DLT/.test(name) && !/台湾/.test(name)) return DLT_TREND_SETTING
    if (/3D/.test(name)) return D3_TREND_SETTING
    if (/四星|万字/.test(name)) return X4_TREND_SETTING
    if (/P3P5|P3|P5/.test(name)) return P3P5_TREND_SETTING
    const len = getDigitLen(game)
    if (len === 7) return /双色球/.test(name) ? SSQ_TREND_SETTING : DLT_TREND_SETTING
    if (len === 3) return D3_TREND_SETTING
    if (len === 4) return X4_TREND_SETTING
    return P3P5_TREND_SETTING
  }
  if (game?.group && TREND_SETTING_BY_GROUP[game.group]) return TREND_SETTING_BY_GROUP[game.group]
  return SSC_TREND_SETTING
}

export const getComboOptions = (game) => getTrendSetting(game).combos

/** 大乐透前区：18–35 为大，01–17 为小 */
export const calcDltFrontAttrs = (frontCodes) => {
  const front = (frontCodes || []).map(Number).filter((n) => Number.isFinite(n))
  while (front.length < 5) front.push(0)
  const sorted = [...front].sort((a, b) => a - b)
  const sum = sorted.reduce((a, b) => a + b, 0)
  const span = sorted.length ? sorted[sorted.length - 1] - sorted[0] : 0
  let odd = 0
  let big = 0
  sorted.forEach((n) => {
    if (n % 2 === 1) odd += 1
    if (n >= 18) big += 1
  })
  return {
    sum,
    span,
    oeRatio: `${odd}:${5 - odd}`,
    bsRatio: `${big}:${5 - big}`
  }
}

export const calcDltBackAttrs = (backCodes) => {
  const back = (backCodes || []).map(Number).filter((n) => Number.isFinite(n))
  while (back.length < 2) back.push(0)
  const sum = back.reduce((a, b) => a + b, 0)
  let odd = 0
  back.forEach((n) => {
    if (n % 2 === 1) odd += 1
  })
  return {
    sum,
    oeRatio: `${odd}:${2 - odd}`
  }
}

/** 大乐透形态走势行 */
export function buildDltFormRows (draws) {
  return (draws || []).map((draw) => {
    const codes = (draw.codes || []).map(Number)
    const front = codes.slice(0, 5)
    const back = codes.slice(5, 7)
    const f = calcDltFrontAttrs(front)
    const b = calcDltBackAttrs(back)
    return {
      issue: draw.issue,
      codes,
      frontSum: f.sum,
      frontSpan: f.span,
      frontOe: f.oeRatio,
      frontBs: f.bsRatio,
      backSum: b.sum,
      backOe: b.oeRatio
    }
  })
}

/** 双色球红球：17–33 为大，01–16 为小 */
export const calcSsqRedAttrs = (redCodes) => {
  const red = (redCodes || []).map(Number).filter((n) => Number.isFinite(n))
  while (red.length < 6) red.push(0)
  const sorted = [...red].sort((a, b) => a - b)
  const sum = sorted.reduce((a, b) => a + b, 0)
  const span = sorted.length ? sorted[sorted.length - 1] - sorted[0] : 0
  let odd = 0
  let big = 0
  sorted.forEach((n) => {
    if (n % 2 === 1) odd += 1
    if (n >= 17) big += 1
  })
  return {
    sum,
    span,
    oeRatio: `${odd}:${6 - odd}`,
    bsRatio: `${big}:${6 - big}`
  }
}

export const calcSsqBlueAttrs = (blueCode) => {
  const n = Number(blueCode)
  if (!Number.isFinite(n) || n <= 0) return { n: 0, bs: '小', oe: '双' }
  return {
    n,
    bs: n >= 9 ? '大' : '小',
    oe: n % 2 ? '单' : '双'
  }
}

/** 双色球形态走势行（红和/跨度/比 + 蓝大小单双） */
export function buildSsqFormRows (draws) {
  return (draws || []).map((draw) => {
    const codes = (draw.codes || []).map(Number)
    const red = codes.slice(0, 6)
    const blue = codes[6]
    const r = calcSsqRedAttrs(red)
    const b = calcSsqBlueAttrs(blue)
    return {
      issue: draw.issue,
      codes,
      redSum: r.sum,
      redSpan: r.span,
      redOe: r.oeRatio,
      redBs: r.bsRatio,
      blueBs: b.bs,
      blueOe: b.oe
    }
  })
}

const hashDigit = (seed, issueIndex, pos) => {
  const x = Math.sin(seed * 12.9898 + issueIndex * 78.233 + pos * 4.1414) * 43758.5453
  return Math.abs(Math.floor(x)) % 10
}

const sscIssue = (offset) => {
  const d = new Date()
  d.setMinutes(d.getMinutes() - offset)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const seq = String(d.getHours() * 60 + d.getMinutes() + 1).padStart(4, '0')
  return `${y}${m}${day}${seq}`
}

export const generateDraws = ({ gameId, digitLen, count, group } = {}) => {
  // 超级大乐透：前区 5/35 + 后区 2/12（勿与 LHC 七码混淆）
  if (Number(gameId) === 16) {
    const list = []
    const seed = 16
    const pick = (max, n, salt) => {
      const pool = Array.from({ length: max }, (_, i) => i + 1)
      for (let k = pool.length - 1; k > 0; k--) {
        const j = hashDigit(seed, salt, k) % (k + 1)
        const tmp = pool[k]
        pool[k] = pool[j]
        pool[j] = tmp
      }
      return pool.slice(0, n).sort((a, b) => a - b)
    }
    let issue = 2026100
    while (list.length < count) {
      const front = pick(35, 5, list.length * 2)
      const back = pick(12, 2, list.length * 2 + 1)
      list.push({
        issue: String(issue - list.length),
        codes: [...front, ...back]
      })
    }
    return list
  }

  // 双色球：红球 6/33 + 蓝球 1/16
  if (Number(gameId) === 17) {
    const list = []
    const seed = 17
    const pick = (max, n, salt) => {
      const pool = Array.from({ length: max }, (_, i) => i + 1)
      for (let k = pool.length - 1; k > 0; k--) {
        const j = hashDigit(seed, salt, k) % (k + 1)
        const tmp = pool[k]
        pool[k] = pool[j]
        pool[j] = tmp
      }
      return pool.slice(0, n).sort((a, b) => a - b)
    }
    let issue = 2026100
    while (list.length < count) {
      const red = pick(33, 6, list.length * 2)
      const blue = pick(16, 1, list.length * 2 + 1)
      list.push({
        issue: String(issue - list.length),
        codes: [...red, ...blue]
      })
    }
    return list
  }

  if (group === 'LHC') {
    const list = []
    const seed = gameId || 1103
    const d = new Date()
    const ymd = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`
    while (list.length < count) {
      const nums = Array.from({ length: 49 }, (_, i) => i + 1)
      for (let k = nums.length - 1; k > 0; k--) {
        const j = Math.abs(Math.floor(Math.sin(seed * 12.9898 + list.length * 78.233 + k * 4.1414) * 43758.5453)) % (k + 1)
        const tmp = nums[k]
        nums[k] = nums[j]
        nums[j] = tmp
      }
      const codes = nums.slice(0, 7)
      const seq = String(count - list.length).padStart(4, '0')
      list.push({ issue: `${ymd}${seq}`, codes })
    }
    return list
  }

  if (group === 'PK10' || digitLen === 10) {
    const list = []
    const seed = gameId || 0
    const arr = () => {
      const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      for (let k = nums.length - 1; k > 0; k--) {
        const j = hashDigit(seed, list.length, k) % (k + 1)
        const tmp = nums[k]
        nums[k] = nums[j]
        nums[j] = tmp
      }
      return nums
    }
    let issueNo = 13746113 + hashDigit(seed, 0, 0) % 9000
    while (list.length < count) {
      list.push({ issue: String(issueNo - list.length), codes: arr() })
    }
    return list
  }

  if (group === 'K3') {
    const list = []
    let seed = (Number(gameId) || 1909) * 9973 + 17
    const next = () => {
      seed = (seed * 1103515245 + 12345) & 0x7fffffff
      return (seed % 6) + 1
    }
    let issue = 14450100
    while (list.length < count) {
      list.push({
        issue: String(issue - list.length),
        codes: [next(), next(), next()]
      })
    }
    return list
  }

  if (group === '11X5') {
    const list = []
    const seed = gameId || 103
    while (list.length < count) {
      const nums = Array.from({ length: 11 }, (_, i) => i + 1)
      for (let k = nums.length - 1; k > 0; k--) {
        const j = hashDigit(seed, list.length, k) % (k + 1)
        const tmp = nums[k]
        nums[k] = nums[j]
        nums[j] = tmp
      }
      list.push({ issue: sscIssue(list.length), codes: nums.slice(0, 5) })
    }
    return list
  }

  if (group === 'PCB') {
    const list = []
    const seed = gameId || 1405
    while (list.length < count) {
      const codes = Array.from({ length: 3 }, (_, pos) => hashDigit(seed, list.length, pos) % 10)
      list.push({ issue: sscIssue(list.length), codes })
    }
    return list
  }

  const list = []
  if (gameId === 15 && digitLen === 5) {
    SAMPLE_P3P5.forEach((row) => {
      if (list.length < count) list.push({ issue: row.issue, codes: [...row.codes] })
    })
  }

  const useSscIssue = group === 'SSC' || (digitLen === 5 && gameId !== 15)
  let nextIssue = list.length
    ? Number(list[list.length - 1].issue) - 1
    : 2026215

  while (list.length < count) {
    const i = list.length
    const codes = Array.from({ length: digitLen }, (_, pos) => hashDigit(gameId || 0, i, pos))
    const issue = useSscIssue ? sscIssue(i) : String(nextIssue)
    list.push({ issue, codes })
    nextIssue -= 1
  }

  return list
}

/** draws 最新在前；命中格 miss=0。opts.winsOf 多码同开；opts.winOf 单点 */
export const buildTrendRows = (draws, position, opts = {}) => {
  const ballMin = opts.ballMin ?? 0
  const size = opts.size ?? 10
  const winsOf = typeof opts.winsOf === 'function'
    ? opts.winsOf
    : typeof opts.winOf === 'function'
      ? (draw) => [opts.winOf(draw)]
      : (draw) => [draw.codes[position] ?? ballMin]
  const oldest = [...draws].reverse()
  const lastHit = Array(size).fill(-1)

  const computed = oldest.map((draw, i) => {
    const raw = winsOf(draw)
    const wins = [...new Set((Array.isArray(raw) ? raw : [raw]).map(Number))]
    const winSlots = wins
      .map((w) => w - ballMin)
      .filter((slot) => slot >= 0 && slot < size)
    const hitSet = new Set(winSlots)
    const miss = Array(size).fill(0)
    for (let d = 0; d < size; d++) {
      if (hitSet.has(d)) {
        miss[d] = 0
        lastHit[d] = i
      } else {
        miss[d] = lastHit[d] < 0 ? i + 1 : i - lastHit[d]
      }
    }
    return {
      issue: draw.issue,
      codes: draw.codes,
      win: wins[0],
      wins,
      winSlot: winSlots[0] ?? -1,
      winSlots,
      miss
    }
  })

  return computed.reverse()
}

export const computeStats = (rows, size = 10) => {
  const n = rows.length
  const count = Array(size).fill(0)
  const maxMiss = Array(size).fill(0)
  const maxStreak = Array(size).fill(0)
  const missRun = Array(size).fill(0)
  const hitRun = Array(size).fill(0)

  ;[...rows].reverse().forEach((row) => {
    const hitSlots = Array.isArray(row.winSlots) && row.winSlots.length
      ? new Set(row.winSlots)
      : new Set([row.winSlot])
    for (let d = 0; d < size; d++) {
      if (hitSlots.has(d) || (row.winSlot == null && row.win === d)) {
        count[d] += 1
        hitRun[d] += 1
        missRun[d] = 0
        maxStreak[d] = Math.max(maxStreak[d], hitRun[d])
      } else {
        hitRun[d] = 0
        missRun[d] += 1
        maxMiss[d] = Math.max(maxMiss[d], missRun[d])
      }
    }
  })

  const avg = count.map((c) => (c ? Math.round(n / c) : 0))
  return { count, avg, maxMiss, maxStreak }
}
